// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"9d0c112e4fe0a0e296df","966":"c12672100878cba6a22e"}[chunkId] + ".js";
};